<script>
    import Row from './Row.svelte';
    export let rows;
</script>

<div class="grid grid-cols-tea-table md:grid-cols-tea-table-large items-center gap-y-3">
    {#if rows}
        {#each rows as row, index}
            <Row row={row.fields} index={index}></Row>
        {/each}
    {/if}
</div>